<template>
  <account-modal class="use-account-for-vault-modal">
    <template slot="heading">
      <div>Use account {{ account.accountId }}<template v-if="account.hasName">&nbsp;“{{ account.name }}”</template> for saving?</div>
    </template>

    <template slot="content">
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onUseButtonClick"
      >use</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'UseAccountForVaultModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    data () {
      return {
        accountUseForVaultApiRequest: new ApiRequest(AccountApi.useForVault)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.userId
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.accountUseForVaultApiRequest.loading
      },
      error () {
        return this.accountUseForVaultApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onUseButtonClick () {
        this.accountUseForVaultApiRequest
          .execute(this.account.accountId)
          .then(this.accountUseForVaultSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      accountUseForVaultSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account has been successfully set for vault use.' }
          })
        }, 100)
      }
    }
  }
</script>
